import { useState } from 'react';

import { useLazyQuery } from '@apollo/client';

import { GET_COMPANY_REPORT } from 'src/graphql/queries/companyReportLookup.query';
import { CompanyReportResponse } from 'types/graphql';

import { onError } from '../../../src/utils/utils';

export const useCompanyReport = () => {
    const [companyReport, setCompanyReport] = useState<CompanyReportResponse>();

    const [companyReportLookup, { loading }] = useLazyQuery(GET_COMPANY_REPORT, {
        fetchPolicy: 'network-only',
        onError: (error) => {
            return onError(error);
        },
        onCompleted: ({ companyReportLookUp }) => {
            setCompanyReport(companyReportLookUp);
        },
    });

    return {
        isLoadingCompanyReport: loading,
        companyReport,
        findCompanyReport: async (
            registrationNumber: string,
            companyBusinessIndicator: string | undefined
        ) => {
            return await companyReportLookup({
                variables: {
                    companyNumber: registrationNumber,
                    companyBusinessIndicator,
                },
            });
        },
    };
};
